export const OVERVIEW_CARD_EMPTY_COPY = {
  testCaseSummary:
    'Add test cases to see a breakdown of automated vs manual coverage.',
  tagBreakdown:
    'Add test cases to see how they are distributed across modules.',
  testCaseGrowth:
    'Growth trends will appear as you add cases to this group over time.',
};

export const LAUNCH_NUDGE_CONTENT = {
  title: 'Ready to run?',
  getDescription: (count) =>
    `You have ${count} test case${count === 1 ? '' : 's'} in this group. Create a launch to execute ${count === 1 ? 'it' : 'them'} against an environment and start tracking results.`,
  ctaLabel: 'Create launch',
};

export const TEST_GROUP_CASES_EMPTY_CONTENT = {
  title: 'No test cases in this group yet',
  description:
    'Add test cases from your library to define what this group will execute when launched.',
  ctaLabel: 'Add test cases',
};

export const CREATE_LAUNCH_DISABLED_TOOLTIP = 'Add test cases before creating a launch';
